function Skeleton({ className = '' }) {
  return (
    <div
      className={`animate-pulse bg-soft-rule rounded ${className}`}
    />
  )
}

export default Skeleton
